import ACTION_TYPES from '../actions/type.action';

const initialState = {
    sideBar: true,
    webView: false,
    
}
export const uiReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.SHOW_WEB_VIEW:
            return {
                ...state,
                webView:true
            }
        case ACTION_TYPES.HIDE_WEB_VIEW:
            return {
                ...state,
                webView:false
            }
             case ACTION_TYPES.SHOW_SIDE_BAR:
            return {
                ...state,
                sideBar:true
            }
        case ACTION_TYPES.HIDE_SIDE_BAR:
            return {
                ...state,
                sideBar:false
            }
        default:
            return state;
}

};


